function setCookie(cname, cvalue, exdays)
{
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));

    let expires = "expires="+ d.toUTCString();

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname)
  {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(let i = 0; i <ca.length; i++)
    {
      let c = ca[i];

      while (c.charAt(0) == ' ')
        c = c.substring(1);
      
      if (c.indexOf(name) == 0)
        return c.substring(name.length, c.length);
    }

    return "";
  }

  const filterToggles = document.querySelectorAll('.k-filter__toggle');
  const filterSearch = document.querySelectorAll(".k-filter__form-search > .k-input--search");
  const filterShowAll = document.querySelectorAll(".k-filter__btn-show");

  if(filterToggles)
  {
      [...filterToggles].forEach(function(item)
      {
          item.addEventListener("click", function(e)
          {
              var filterCookie = getCookie("filterToggle");

              var filters = [];

              if(filterCookie != "")
                filters = JSON.parse(filterCookie);

              if(filters.includes(this.dataset.id))
              {
                filters.splice(filters.indexOf(this.dataset.id), 1);

                if(this.previousElementSibling.tagName === "SPAN")
                  this.previousElementSibling.classList.add("k-d-none");
              }
              else
              {
                filters.push(this.dataset.id);

                if(this.previousElementSibling.tagName === "SPAN" && this.previousElementSibling.innerText != "0")
                  this.previousElementSibling.classList.remove("k-d-none");
              }

              setCookie("filterToggle", JSON.stringify(filters), 365);
          });
      });
  }

  if(filterSearch)
  {
      [...filterSearch].forEach(function(item)
      {
          item.addEventListener("keyup", function(e)
          {
              var value = this.value;

              [...this.parentElement.nextElementSibling.childNodes].forEach(function(element)
              {
                  if(element.tagName !== "LI")
                    return;

                  const childs = element.querySelectorAll(":scope .k-checkbox__label");

                  [...childs].forEach(function(child)
                  {
                    let parent = child.parentElement;

                    if(child.innerText.toLowerCase().includes(value.toLowerCase()))
                    {
                      while(parent.tagName !== "LI")
                        parent = parent.parentElement;

                      parent.classList.remove("k-d-none");
                    }
                    else
                    {
                      while(parent.tagName !== "LI")
                        parent = parent.parentElement;

                      parent.classList.add("k-d-none");
                    }
                  });
              })
          });
      })
  }

  if(filterShowAll)
  {
      [...filterShowAll].forEach(function(item)
      {
          item.addEventListener("click", function(e)
          {
              var filterCookie = getCookie("filterShowAll");

              var showAll = [];

              if(filterCookie != "")
                showALl = JSON.parse(filterCookie);

              if(!showAll.includes(this.dataset.filterId))
                showAll.push(this.dataset.filterId);

              setCookie("filterShowAll", JSON.stringify(showAll), 365);
          });
      })
  }